import toast from "react-hot-toast";
import * as api from "../Api";

export const getAllLocationReceived = () => async (dispatch) => {
  try {
    const { data } = await api.locationReceived();
    dispatch({ type: "ALL_LOCATION_RECEIVED", payload: data });
  } catch (error) {}
};

// The branch confirming an issue arrived
export const updateLocationReceived = (id, postData) => async (dispatch) => {
  try {
    await api.updateReceipt(id, postData);
    dispatch({ type: "UPDATE_RECEIPT", payload: id });
  } catch (error) {
    toast.error(error.response?.data?.message || "Couldn't confirm. Try again.");
    throw error;
  }
};
